import { useContext } from "react";
import { Grid, Stack, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
//Srcs
import "./setting.scss";
import User from "../../Assets/add-user.png";
import Shift from "../../Assets/shift.png";
// import Class from "../../Assets/class.png";
import GroupFee from "../../Assets/groupfee.png";
import Course from "../../Assets/course.png";
import Exam from "../../Assets/exam-img.png";
import Subject from "../../Assets/subject-img.png";
import Expense from "../../Assets/expense_icon.png";
import ShowType from "../../Assets/show-type.png";
import UserAction from "../../Assets/user-action.png";
import OnlineBook from "../../Assets/online-book.png";
import { AuthContext } from "../../Context/AuthContext";
import { PageHeaderTitle } from "../../Utils/Component";

export default function Setting() {
  // Change Language
  const { t } = useContext(AuthContext);
  const userLogin = JSON.parse(window.localStorage.getItem("userLogin"));

  const SettingData = [
    {
      icon: <img alt="Exam icon" className="image" src={UserAction} />,
      path: "/setting/user-action",
      title: t("page_user_action"),
      description: t("thead_description_user_action"),
    },
    {
      icon: <img alt="Exam icon" className="image" src={User} />,
      path: "/setting/user",
      title: t("page_user"),
      description: t("thead_description_user"),
    },
    {
      icon: <img alt="Exam icon" className="image" src={GroupFee} />,
      path: "/setting/group-fee",
      title: t("page_group_fee"),
      description: t("thead_description_group_fee"),
    },
    {
      icon: <img alt="Exam icon" className="image" src={Shift} />,
      path: "/setting/shift",
      title: t("page_shift"),
      description: t("thead_description_shift"),
    },
    {
      icon: <img alt="Exam icon" className="image" src={Course} />,
      path: "/setting/course",
      title: t("page_course"),
      description: t("thead_description_course"),
    },
    {
      icon: <img alt="Exam icon" className="image" src={Subject} />,
      path: "/setting/subject",
      title: t("page_subject"),
      description: t("thead_description_subject"),
    },
    {
      icon: <img alt="Exam icon" className="image" src={Exam} />,
      path: "/setting/exam-type",
      title: t("page_exam_type"),
      description: t("thead_description_exam_type"),
    },
    {
      icon: <img alt="Exam icon" className="image" src={ShowType} />,
      path: "/setting/performance-type",
      title: t("page_performance_type"),
      description: t("thead_description_performance_type"),
    },
    {
      icon: <img alt="Exam icon" className="image" src={Expense} />,
      path: "/setting/expense-type",
      title: t("page_expense_type"),
      description: t("thead_description_expense_type"),
    },
    {
      icon: <img alt="Exam icon" className="image" src={OnlineBook} />,
      path: "/setting/online-book",
      title: t("page_online_book"),
      description: t("thead_online_book_des"),
    },
  ];

  const SettingTeacherData = [
    {
      icon: <img alt="Exam icon" className="image" src={OnlineBook} />,
      path: "/setting/online-book",
      title: t("page_online_book"),
      description: t("thead_online_book_des"),
    },
  ];

  return (
    <div className="setting-page">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={"/other"}
        pageTitle={t("page_setting")}
      />

      <Box sx={{ mt: "30px" }}>
        {userLogin?.user?._id === "6a35180771962a1bcdc6d96e" ? (
          <Grid container spacing={4}>
            {SettingTeacherData?.map((e, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <Link to={e?.path} style={{ textDecoration: "none" }}>
                  <Stack
                    spacing={3}
                    direction="row"
                    className="setting-page-container"
                  >
                    <Stack
                      direction="column"
                      justifyContent="center"
                      className="page-image"
                    >
                      {e?.icon}
                    </Stack>
                    <Stack direction="column" justifyContent="center">
                      <Stack direction="column">
                        <Typography className="page-title">
                          {e?.title}
                        </Typography>
                        <Typography className="page-description">
                          {e?.description}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                </Link>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Grid container spacing={4}>
            {SettingData?.map((e, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <Link to={e?.path} style={{ textDecoration: "none" }}>
                  <Stack
                    spacing={3}
                    direction="row"
                    className="setting-page-container"
                  >
                    <Stack
                      direction="column"
                      justifyContent="center"
                      className="page-image"
                    >
                      {e?.icon}
                    </Stack>
                    <Stack direction="column" justifyContent="center">
                      <Stack direction="column">
                        <Typography className="page-title">
                          {e?.title}
                        </Typography>
                        <Typography className="page-description">
                          {e?.description}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                </Link>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </div>
  );
}
